export default "__VITE_ASSET__CYIE8Ckh__"